<template>
    <b-container>
        <List :items="users" :fields="fields"/>
    </b-container>
</template>

<script>
    import List from '@/components/admin/List'
    import {mapActions,mapState} from 'vuex'
    export default {
        components:{
            List
        },    
        data:function () {
            return{
                fields:['username','email','name','telefono','Acciones']
            }            
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState('admin',['users'])
        },
        methods:{
            ...mapActions({
                _fetchUsers: 'admin/fetchUsers'   
            }),
            init(){
                this._fetchUsers()
            }
        }    
    }
</script>

<style lang="scss" scoped>

</style>